import StaffDashboard from './pages/Staff/Dashboard/index'
import Top from './pages/Landing/Top/index'
import Item from './pages/Landing/Item/index'
import Contact from './pages/Landing/Contact/index'
import Press from './pages/Landing/Press/index'
import Freezer from './pages/Landing/Freezer/index'
import Download from './pages/Landing/Download/index'
// import Shop from './pages/Shop/Top/index'
// import Cart from './pages/Shop/Cart/index'
// import CartConfirm from './pages/Shop/CartConfirm/index'
// import CartDanke from './pages/Shop/CartDanke/index'
// import Guide from './pages/Shop/Guide/index'
// import Privacy from './pages/Shop/Privacy/index'
// import ShopContact from './pages/Shop/Contact/index'
// import ContactDanke from './pages/Shop/ContactDanke/index'

import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'

Vue.use(VueScrollTo)

Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})

export default [
  {
    path: '/dashboard',
    redirect: '/top'
  },
  {
    path: '/staff/dashboard',
    name: 'staff_dashboard',
    component: StaffDashboard,
    meta: { requiresAuth: true, requiresRoles: ['user'], layout: 'app-layout-default', applicationClasses: ['application-biz'] }
  },
  {
    path: '/top',
    name: 'top',
    component: Top,
    meta: { requiresAuth: false, layout: 'app-layout-simple' }
  },
  {
    path: '/item',
    name: 'item',
    component: Item,
    meta: { requiresAuth: false, layout: 'app-layout-simple' }
  },
  {
    path: '/freezer',
    name: 'freezer',
    component: Freezer,
    meta: { requiresAuth: false, layout: 'app-layout-simple' }
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact,
    meta: { requiresAuth: false, layout: 'app-layout-simple' }
  },
  {
    path: '/press',
    name: 'press',
    component: Press,
    meta: { requiresAuth: false, layout: 'app-layout-simple' }
  },
  {
    path: '/download',
    name: 'download',
    component: Download,
    meta: { requiresAuth: false, layout: 'app-layout-simple' }
  }
  // {
  //   path: '/shop',
  //   name: 'shop',
  //   component: Shop,
  //   meta: { requiresAuth: false, layout: 'app-layout-simple' }
  // },
  // {
  //   path: '/shop_cart',
  //   name: 'cart',
  //   component: Cart,
  //   meta: { requiresAuth: false, layout: 'app-layout-simple' }
  // },
  // {
  //   path: '/shop_cart_confirm',
  //   name: 'cart_confirm',
  //   component: CartConfirm,
  //   meta: { requiresAuth: false, layout: 'app-layout-simple' }
  // },
  // {
  //   path: '/shop_cart_danke/:id',
  //   name: 'cart_danke',
  //   component: CartDanke,
  //   meta: { requiresAuth: false, layout: 'app-layout-simple' }
  // },
  // {
  //   path: '/shop_guide',
  //   name: 'guide',
  //   component: Guide,
  //   meta: { requiresAuth: false, layout: 'app-layout-simple' }
  // },
  // {
  //   path: '/shop_privacy',
  //   name: 'privacy',
  //   component: Privacy,
  //   meta: { requiresAuth: false, layout: 'app-layout-simple' }
  // },
  // {
  //   path: '/shop_contact',
  //   name: 'shop_contact',
  //   component: ShopContact,
  //   meta: { requiresAuth: false, layout: 'app-layout-simple' }
  // },
  // {
  //   path: '/shop_contact_danke/:id',
  //   name: 'shop_contact_danke',
  //   component: ContactDanke,
  //   meta: { requiresAuth: false, layout: 'app-layout-simple' }
  // }
]



// WEBPACK FOOTER //
// ./src/app/routes.js